import { render, staticRenderFns } from "./RegisterOpportunities.vue?vue&type=template&id=19e0240c"
import script from "./RegisterOpportunities.vue?vue&type=script&lang=js"
export * from "./RegisterOpportunities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports